import * as actions from '../../actions/actions'

const initialState = {
  banks: [],
  error: null
  // isModalOpen:false
}

export default function bank(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_BANKS_SUCCESS:
      return fetchBankSuccess(state, action)
    case actions.FETCH_BANKS_FAILURE:
      return fetchBankFailure(state, action)
    case actions.ENABLE_BANK_SUCCESS:
      return enableBankSuccess(state, action)
    case actions.ENABLE_BANK_FAILURE:
      return enableBankFailure(state, action)
    case actions.DISABLE_BANK_SUCCESS:
      return disableBankSuccess(state, action)
    case actions.DISABLE_BANK_FAILURE:
      return disableBankFailure(state, action)
    case actions.DELETE_BANK_SUCCESS:
      return deleteBankSuccess(state, action)
    case actions.DELETE_BANK_FAILURE:
      return deleteBankFailure(state, action)
    // case actions.TOGGLE_MODAL:
    //   return toggleModal(state,action)
    default:
      return state
  }
}

const enableBankSuccess = (state, action) => {
  return {
    ...state,
    banks: action.banks
  }
}

const enableBankFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const disableBankSuccess = (state, action) => {
  return {
    ...state,
    banks: action.banks
  }
}

const disableBankFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const fetchBankSuccess = (state, action) => {
  return {
    ...state,
    banks: action.banks
  }
}

const fetchBankFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const deleteBankSuccess = (state, action) => {
  return {
    ...state,
    banks: action.banks
  }
}

const deleteBankFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}
